import { localStorageService } from '../services/localStorageService';

export const getLocalStorageItem = (userId: string, key: string) => {
  const item = localStorageService?.getItem(userId);
  if (item) {
    return JSON.parse(item)[key];
  } else {
    return null;
  }
};

export const setLocalStorageItem = (userId: string, key: string, data: any) => {
  const item = localStorageService?.getItem(userId);
  if (item) {
    const newItem = Object.assign({}, JSON.parse(item));
    newItem[key] = data;
    localStorageService?.setItem(userId, JSON.stringify(newItem));
  } else {
    const newProperty = { [key]: data };
    localStorageService?.setItem(userId, JSON.stringify(newProperty));
  }
};

export const removeLocalStorageItem = (userId: string, key: string) => {
  let item = localStorageService?.getItem(userId);
  item = typeof item === 'string' ? JSON.parse(item) : item;
  if (item) {
    const newItem: any = Object.assign({}, item);
    delete newItem[key];
    localStorageService?.setItem(userId, JSON.stringify(newItem));
  }
};

export function clearStoredReduxState() {
  localStorageService?.removeItem('reduxPersist:simulation');
  localStorageService?.removeItem('reduxPersist:editor');
}
